<ul class="navbar-nav mr-auto float-left">
    <li (click)="toggleSidebar.emit()" class="nav-item m-l-1 d-block"> <a
            class="nav-link sidebartoggler text-muted waves-effect waves-dark p-1" href="javascript:void(0)"><i
                class="mdi mdi-menu mdi-24px"></i></a> </li>
</ul>